module.exports = __webpack_public_path__ + "img/17.ef82bd77.png";